import { useLayoutEffect } from "react";
import { Location, Route, Routes, useLocation } from "react-router-dom";
import Menu from "./components/Menu/Menu";
import ScrollRevealManager from "./components/ScrollReveal/ScrollRevealManager";
import Home from "./pages/Home/Home";
import ProductPlaceholder from "./pages/ProductPlaceholder/ProductPlaceholder";
import CemLife from "./pages/CemLife/CemLife";
import CemTest from "./pages/CemTest/CemTest";
import StaffTraining from "./pages/StaffTraining/StaffTraining";
import RepairWorks from "./pages/RepairWorks/RepairWorks";
import { cancelPendingScroll, scrollTo } from "./hooks/scrollTo";
import { HomeNavigationState } from "./hooks/useHomeNavigation";
import { ActiveRoutePage } from "./App.styles";

const clearHomeNavigationState = () => {
  const historyState = window.history.state;

  if (historyState && "usr" in historyState) {
    window.history.replaceState({ ...historyState, usr: null }, "");
  }
};

const RouteScrollManager = ({ location }: { location: Location }) => {
  useLayoutEffect(() => {
    const navigationState = location.state as HomeNavigationState | null;
    const target = navigationState?.scrollTo;

    cancelPendingScroll(false);

    if (location.pathname === "/" && target) {
      // The target is only needed for this transition. Keeping it in history
      // makes the browser repeat the scroll after a page refresh.
      clearHomeNavigationState();

      if (target !== "top" && scrollTo(target, "auto")) return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.key, location.pathname, location.state]);

  return null;
};

const PageRoutes = () => {
  const location = useLocation();

  return (
    <>
      <RouteScrollManager location={location} />
      <ScrollRevealManager />
      <ActiveRoutePage data-route-active="true">
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/products/:slug" element={<ProductPlaceholder />} />
          <Route path="/products/cemlife" element={<CemLife />} />
          <Route path="/products/cemtest" element={<CemTest />} />
          <Route path="/products/staff-training" element={<StaffTraining />} />
          <Route
            path="/products/repair-and-insulation"
            element={<RepairWorks />}
          />
        </Routes>
      </ActiveRoutePage>
    </>
  );
};

function App() {
  return (
    <>
      <Menu />
      <PageRoutes />
    </>
  );
}

export default App;
